export const ANALYSIS_REFLECTION_COMMENT = 'analysisReflectionComment';
export const ANALYSIS_SIGNIFICANT_ELEMENT = 'analysisSignificantElement';
export const ANALYSIS_DOCUMENT = 'analysisDocument';
